'use strict';

var superagent = require('superagent');
var cookie = require('react-cookie');
var Helpers = require('./helpers');

var _require = require('../../config/generatedConfig'),
    domainSettings = _require.domainSettings,
    settings = _require.settings,
    agents = _require.agents,
    customerWebSocketService = _require.customerWebSocketService;

var GetAgentData = {
  agentFromReferrer: function agentFromReferrer() {
    var referrer = typeof window !== 'undefined' ? window.document.referrer : '';
    var seoSearch = new RegExp(/^[a-z]*:\/\/[^/]*(\.google\.|\.yahoo\.|\.bing\.|\.ask\.|\.aol\.|\.wow\.|\.webcrawler\.|\.mywebsearch\.|\.infospace\.|\.info\.|\.dogpile\.|\.duckduckgo\.|\.blekko\.)[^/]*/i);
    if (referrer && seoSearch.test(referrer) && !Helpers.getParameterByName('adcode', true) && !Helpers.getParameterByName('email', true)) {
      return agents.search || this.getDefaultAgent(agents.main);
      // If SEO referer and not got url params of email or adcode then set to searchagent code
    }
  },
  agentFromUrl: function agentFromUrl() {
    var urlAgent = Helpers.getParameterByName('agent', true);
    var agentTest = new RegExp(/^[0-9a-z]{4,5}$/i);
    if (urlAgent && agentTest.test(urlAgent)) {
      return urlAgent;
    }
  },
  agentFromCookie: function agentFromCookie() {
    if (cookie.load('agent')) {
      return cookie.load('agent');
    }
  },
  getDefaultAgent: function getDefaultAgent(agent) {
    return agent || agents.main || 'WT894';
  },
  getAgent: function getAgent() {
    var agent = this.agentFromReferrer() || this.agentFromUrl() || this.agentFromCookie() || this.getDefaultAgent();
    this.setAgentCookie(agent);
    this.checkForSessionCookie(); // This is only here for audience_segments
    return agent;
  },
  setAgentCookie: function setAgentCookie(agent) {
    cookie.remove('agent', '/');
    var expiry = new Date();
    var cookieDays = settings.cookieExpiryDays || 90;
    expiry.setTime(expiry.getTime() + cookieDays * 24 * 60 * 60 * 1000);
    var opts = { expires: expiry, path: '/' };
    if (settings.cookieDomain) opts.domain = settings.cookieDomain;
    cookie.save('agent', agent, opts);
  },
  agentData: function agentData(obj, initial) {
    var data = {};
    if (initial) {
      try {
        data = require('../' + settings.pluginsExportDir + '/' + agents.main + '.json');
        data.agent = data.code;
      } catch (e) {
        data = {};
      }
    }
    if (!data.agent) {
      data = {
        agent: this.getAgent(),
        typeRID: 'D',
        groupCode: 'X0'
      };
      if (obj) return Object.prototype.hasOwnProperty.call(data, obj) ? data[obj] : false;
    }
    return data;
  },
  getLocation: function getLocation() {
    if (domainSettings.country) {
      return domainSettings.country.toUpperCase();
    }
    if (domainSettings.language) {
      return domainSettings.language.toUpperCase();
    }
    return 'UK';
  },
  checkAgent: function checkAgent(agent, cb) {
    if (this.agentData('DDI') && this.agentData('DDI') !== '') return cb(this.agentData());
    var defaultLocation = this.getLocation();
    if (defaultLocation !== 'UK' && defaultLocation !== 'DE') defaultLocation = 'DE'; // Force all other countries but UK to DE
    var scheme = domainSettings.scheme ? domainSettings.scheme + ':' : '';
    try {
      superagent.get(scheme + '//hapi.holidayextras.co.uk/legacy/agent_lookup/' + agent + '.js?key=foo&country=' + defaultLocation).end(function (err, res) {
        if (err || !res.text) return;
        var record = {};
        try {
          record = JSON.parse(res.text);
        } catch (error) {
          console.log(error);
          return;
        }
        if (!(record.API_Reply.RecordSet && record.API_Reply.RecordSet.Record)) return;
        record.API_Reply.RecordSet.Record.map(function (item) {
          var name = item.name,
              code = item.code,
              groupCode = item.groupCode,
              typeRID = item.typeRID,
              DDI = item.DDI,
              promocode = item.promocode,
              cashback = item.cashback,
              data = item.data;

          if (isNaN(agent) && agent.toUpperCase() !== code.toUpperCase()) return;
          var result = {
            name: name,
            agent: agent,
            typeRID: typeRID,
            groupCode: groupCode,
            DDI: DDI,
            promocode: promocode,
            cashback: cashback,
            OptionFlags: data.OptionFlags
          };

          cb(result);
        });
      });
    } catch (e) {
      console.log(e.message, 'ERROR with agent lookup');
      return cb(this.agentData());
    }
  },
  assignAgentsIdentifiedByUrl: function assignAgentsIdentifiedByUrl(agentData) {
    var agentIDs = {};
    if (agentData && agentData.allowedUrlAgentIDs) {
      agentData.allowedUrlAgentIDs.forEach(function (urlAgent) {
        agentIDs[urlAgent] = Helpers.getParameterByName(urlAgent, false);
      });
      return agentIDs;
    }
  },
  componentDidMount: function componentDidMount(agentData) {
    if (agentData.agent !== this.getDefaultAgent()) this.checkAgent(agentData.agent, this.updateAgentData);
  },
  getInitialState: function getInitialState() {
    return this.agentData(false, true);
  },
  updateAgentData: function updateAgentData(data) {
    var result = this.assignAgentsIdentifiedByUrl();
    if (result) data.agentsByUrl = result;
    data.agent = data.agent.toUpperCase();
    return data;
  },
  checkIsLoggedIn: function checkIsLoggedIn() {
    if (!window.ReactRootStore) return false;
    if (!window.ReactRootStore.getState) return false;
    if (typeof window.ReactRootStore.getState !== 'function') return false;
    if (!(window.ReactRootStore.getState().loggedInData || {}).email) return false;
    return true;
  },
  checkForSessionCookie: function checkForSessionCookie() {
    var sessionCookie = cookie.load('owts-tmp-v2');
    if (typeof window === 'undefined' || !customerWebSocketService) return;
    if (!sessionCookie) return setTimeout(this.checkForSessionCookie.bind(this), 500);
  }
};

module.exports = GetAgentData;


// WEBPACK FOOTER //
// ./_plugins/lib/agents.js